var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"md-layout"},[_c('div',{staticClass:"breadcrumb-wrapper md-layout-item"},[(_vm.show)?_c('Breadcrumbs'):_vm._e()],1)])}
var staticRenderFns = []

export { render, staticRenderFns }